module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/Precipitation/Tokyo_Precipitation_MRI_RCP85_End.png";